import { render, staticRenderFns } from "./ModalEditCompany.vue?vue&type=template&id=771b7ca2&scoped=true"
import script from "./ModalEditCompany.vue?vue&type=script&lang=js"
export * from "./ModalEditCompany.vue?vue&type=script&lang=js"
import style0 from "./ModalEditCompany.vue?vue&type=style&index=0&id=771b7ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b7ca2",
  null
  
)

export default component.exports